import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ASAP } from "app/auth/baseAsap";

export const getListaPedidos = createAsyncThunk(
  "listaPedidosApp/listaPedidos/getListaPedidos",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP.get("/pedidos/DIRETO", {
        params: params,
      });
    } catch (err: any) {
      console.error(err.response);
    }
    return response.data;
  }
);
